import { render, staticRenderFns } from "./CasesDocumentsModal.vue?vue&type=template&id=39c63e2e"
import script from "./CasesDocumentsModal.vue?vue&type=script&lang=js"
export * from "./CasesDocumentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports